/*
  Store Builder craft: a colour's photo over the gallery (19 Oct 2026; store-kit/README.md, "Craft hooks"). Split from
  store-builder-craft-colour.js to keep both under the 10 KB patch limit; deferred just before it, which lays its hover
  photo (H1) with these (window.sbColourPhoto). No network, no markup from strings.
  - main: the photo most in view; fetched: a colour's photo fetched ahead (.sb-colour-preload, data_sb_colour);
  - lay: a layer on a photo's own rect, just before the gallery.
  20 Oct 2026: the layered slide, the thumbnail cover and their sides (slide, cover, side, caught) are gone. Every
  colour's photo is now a slide of the gallery's own carousel, and a colour pick moves that carousel
  (store-builder-craft-colour.js, whose post-mortem says why).
*/
(() => {
if (window.sbColourPhoto) return;

const doc = document;
const ready = (img) => Boolean(img?.complete && img.naturalWidth > 0);
const src = (img) => img.currentSrc || img.src;
// The photo most in view, inside its carousel and the window.
function main(gallery) {
  let best = null;
  let most = 0;
  for (const img of gallery.querySelectorAll('slideshow-slide img')) {
    const [r, b] = [img, img.closest('slideshow-container')].map((el) => el.getBoundingClientRect());
    const w = Math.min(r.left + r.width, b.left + b.width, innerWidth) - Math.max(r.left, b.left, 0);
    const h = Math.min(r.top + r.height, b.top + b.height, innerHeight) - Math.max(r.top, b.top, 0);
    if (w > 0 && h > 0 && w * h > most) [best, most] = [img, w * h];
  }
  return best || gallery.querySelector('slideshow-slide img');
}
const fetched = (section, name, value) => [...section.querySelectorAll('.sb-colour-preload img')].find((img) => img.getAttribute(name) === value);

// A layer exactly over the img `over` (round 8: its own rect, as Heritage's inset frame), laid just before the gallery:
// `from`'s photo, in the shown photo's object-fit and -position.
function lay(over, from, gallery, className) {
  const layer = Object.assign(doc.createElement('img'), { className, alt: '', src: src(from) });
  layer.setAttribute('aria-hidden', 'true');
  gallery.before(layer);
  const anchor = layer.offsetParent || doc.body;
  const [r, a] = [over, anchor].map((el) => el.getBoundingClientRect());
  const look = getComputedStyle(over);
  Object.assign(layer.style, {
    left: `${r.left - a.left - anchor.clientLeft}px`, top: `${r.top - a.top - anchor.clientTop}px`, width: `${r.width}px`,
    height: `${r.height}px`, objectFit: look.objectFit, objectPosition: look.objectPosition,
  });
  return layer;
}

window.sbColourPhoto = { ready, src, main, fetched, lay };
})();
